import React from 'react';
import experience from '../../data/experience';
import SectionHeading from '../ui/SectionHeading';
import styles from './ExperienceTimeline.module.css';

export default function ExperienceTimeline({ items = experience }) {
  return (
    <section id="experience" className={styles.section} aria-labelledby="experience-title">
      <SectionHeading
        id="experience-title"
        description="A compact chronology of companies, roles, and dates."
      >
        Experience
      </SectionHeading>

      <ol className={styles.entries}>
        {items.map((item) => {
          const link = item.link || item.links?.company || '';
          return (
            <li className={styles.entry} data-experience-entry key={item.slug}>
              <span className={styles.company}>
                {link ? (
                  <a href={link} target="_blank" rel="noreferrer">
                    {item.company}
                  </a>
                ) : (
                  item.company
                )}
              </span>
              <span className={styles.separator}> — </span>
              <span className={styles.role}>{item.role}</span>
              <span className={styles.separator}> — </span>
              <span className={styles.period}>{item.period}</span>
            </li>
          );
        })}
      </ol>
    </section>
  );
}
